import { render, staticRenderFns } from "./tableAllCargosFin.vue?vue&type=template&id=13b1bfd4&"
import script from "./tableAllCargosFin.vue?vue&type=script&lang=js&"
export * from "./tableAllCargosFin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports